import { TherapistAction } from 'src/redux/actions/constant';

const intialState: object = {
  response: null,
  data: [],
  loading: false,
  isError: false,
  isSuccess: false,
};

export const therapistPatientUnAssignReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case TherapistAction.THERAPIST_PATIENT_UNASSIGN_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        data: action.payload,
        loading: false,
        isError: false,
        isSuccess: true,
      };
    }
    case TherapistAction.THERAPIST_PATIENT_UNASSIGN_FAILURE: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
        isError: true,
      };
    }
    case TherapistAction.THERAPIST_PATIENT_UNASSIGN_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case TherapistAction.THERAPIST_PATIENT_UNASSIGN_RESET:
      return intialState;

    default:
      return state;
  }
};
